import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export interface IWorkflowTable1 {
  id: string;
  description: string;
}

export interface IWorkflowTable2 {
  id: string;
  min_approval: string;
  step_order: string;
  workflow_id: string;
}

export interface IWorkflowTable3 {
  id: string;
  step_code: string;
  approver: string;
  is_role: string;
  min_approval: string;
  step_description: string;
  step_id: string;
  is_reject_atomic: string;
}

export const WORKFLOW_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_WORKFLOW_MGMT,
  MATCHING_RULES: `${ROUTES.ADMIN_WORKFLOW_MGMT}/matchingRules`,
  STEP_TWO: `${ROUTES.ADMIN_WORKFLOW_MGMT}/stepTwo`,
};

export const STATE_IDENTIFIER = {
  WORKFLOW: "workflow",
  WORKFLOW_STEP: "workflowStep",
  WORKFLOW_STEP_CONFIGURATION: "workflowStepConfiguration",
  ADDED: "added",
  MODIFIED: "modified",
  REQUEST_STATE: "requestState",
  WORKFLOW_TABLE: "workflowTable",
  WORKFLOW_STEP_TABLE: "workflowStepTable",
  WORKFLOW_STEP_CONFIGURATION_TABLE: "workflowStepConfigurationTable",
  MATCHING_RULES: "matchingRules",
  RULES: "rules",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";

export interface IDeleteWorkflowObj1 {
  id: string[];
}

export interface IDeleteWorkflowObj2 {
  id: number[];
}

export interface IDeleteWorkflowObj3 {
  stepCode: string[];
}
